import ApiService from "@/common/api.service"

export const UserGroupService = {
    create(params) {
        return ApiService.post("groups/add", params);
    },
    update(slug, params) {
        return ApiService.update("groups", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("user/registerGroup/delete", slug, params)
    },
    async getUserGroups() {
        const res = await ApiService.get("groups");
        return res.data
    },

    async getUserGroupsWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/groups?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data
    }

}